import gql from "graphql-tag";
import { expenseFragment } from "./fragments";

export const GET_PROJECT_EXPENSES = gql`
  query getProjectExpenses($projectId: ID!, $offset: Int!, $limit: Int) {
    projectExpenses(projectId: $projectId, offset: $offset, limit: $limit) {
      hasMore
      items {
        ...ExpenseFragment
      }
    }
  }
  ${expenseFragment}
`;
